<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" sm="6" md="4" lg="4" class="d-flex">
        <TotalEmployeesChart />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="d-flex">
        <ContactMessageWebSite />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="d-flex">
        <Birthdays />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12">
        <ListEmployees />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import TotalEmployeesChart from './components/TotalEmployeesChart'
import ListEmployees from '@/components/layouts/dashboard/ListEmployees'
import ContactMessageWebSite from './components/ContactMessageWebSite'
import Birthdays from './components/Birthdays'

export default {
  name: 'Home',
  components: {
    ListEmployees,
    Birthdays,
    ContactMessageWebSite,
    TotalEmployeesChart,
  },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
